__turbopack_context__.v({
  "cancelText": "ExpandableOrderSummary-module__I_5PIq__cancelText",
  "cart": "ExpandableOrderSummary-module__I_5PIq__cart",
  "chevron": "ExpandableOrderSummary-module__I_5PIq__chevron",
  "container": "ExpandableOrderSummary-module__I_5PIq__container",
  "containerExpanded": "ExpandableOrderSummary-module__I_5PIq__containerExpanded",
  "content": "ExpandableOrderSummary-module__I_5PIq__content",
  "discountedPrice": "ExpandableOrderSummary-module__I_5PIq__discountedPrice",
  "fullPrice": "ExpandableOrderSummary-module__I_5PIq__fullPrice",
  "header": "ExpandableOrderSummary-module__I_5PIq__header",
  "headerCosts": "ExpandableOrderSummary-module__I_5PIq__headerCosts",
  "ongoingCosts": "ExpandableOrderSummary-module__I_5PIq__ongoingCosts",
  "totalText": "ExpandableOrderSummary-module__I_5PIq__totalText",
});
